import Nav from "../Nav";
import Footer from "../Footer";


import React from 'react';

const TermsAndConditionsPage = () => {
    return (
        <div style={{backgroundColor:'white'}}>
            <Nav />
            <body class="font-sans text-gray-800 leading-relaxed m-5" style={{backgroundColor:'white'}}>

                <h1 class="text-3xl font-bold text-center text-gray-900 mb-4">Tutorspace Terms and Conditions</h1>
                <p class="text-center italic"><strong>Last Updated: 10-27-2024</strong></p>

                <p class="mt-6">Welcome to Tutorspace! These Terms and Conditions ("<strong>Terms</strong>") govern your use of the Tutorspace platform, website, and services (collectively, the "<strong>Services</strong>"). By accessing or using our Services, you agree to be bound by these Terms. If you do not agree with these Terms, please do not use our Services.</p>

                <div class="mt-8">
                    <h2 class="text-2xl font-semibold text-gray-900 mt-6">1. Definitions</h2>
                    <ol class="list-decimal list-inside mt-2 space-y-2">
                        <li><strong>"Tutorspace," "we," "us," or "our"</strong> refers to Tutorspace LLC, the provider of the Services.</li>
                        <li><strong>"User," "you," or "your"</strong> refers to any individual or entity who accesses or uses the Services.</li>
                        <li><strong>"Student"</strong> refers to an individual receiving tutoring services through Tutorspace.</li>
                        <li><strong>"Tutor"</strong> refers to an individual providing tutoring services through Tutorspace.</li>
                    </ol>
                </div>

                <div class="mt-8">
                    <h2 class="text-2xl font-semibold text-gray-900 mt-6">2. Services</h2>
                    <ol class="list-decimal list-inside mt-2 space-y-2">
                        <li>Tutorspace offers a platform that connects students with qualified tutors for personalized tutoring sessions.</li>
                        <li>Tutorspace does not guarantee specific results or outcomes from tutoring sessions. The effectiveness of tutoring depends on the efforts of both the tutor and the student.</li>
                        <li>Tutorspace reserves the right to modify or discontinue any part of the Services at any time, with or without notice.</li>
                    </ol>
                </div>

                <div class="mt-8">
                    <h2 class="text-2xl font-semibold text-gray-900 mt-6">3. User Accounts</h2>
                    <ol class="list-decimal list-inside mt-2 space-y-2">
                        <li>To access certain features of the Services, you must create a user account. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.</li>
                        <li>You agree to provide accurate, current, and complete information during the registration process and to update such information to keep it accurate, current, and complete.</li>
                        <li>Tutorspace reserves the right to suspend or terminate accounts that violate these Terms or for other reasons deemed appropriate.</li>
                    </ol>
                </div>

                <div class="mt-8">
                    <h2 class="text-2xl font-semibold text-gray-900 mt-6">4. Payments and Refunds</h2>
                    <ol class="list-decimal list-inside mt-2 space-y-2">
                        <li>Students may be required to pay for tutoring sessions or subscription fees as part of the Services. Payment terms are outlined at the time of purchase.</li>
                        <li>All payments are processed through our third-party payment processors, and Tutorspace does not store credit card information.</li>
                        <li>Tutorspace offers a limited refund policy based on circumstances such as missed sessions or tutor availability issues. Refund requests must be submitted in writing within [X] days of the session.</li>
                        <li>Subscription fees are billed on a recurring basis and are non-refundable once billed, except as required by law.</li>
                    </ol>
                </div>

                <div class="mt-8">
                    <h2 class="text-2xl font-semibold text-gray-900 mt-6">5. User Conduct</h2>
                    <ol class="list-decimal list-inside mt-2 space-y-2">
                        <li>You agree to use the Services only for lawful purposes and in a way that does not infringe the rights of, restrict, or inhibit anyone else's use of the Services.</li>
                        <li>You shall not engage in any of the following prohibited activities:
                            <ul class="list-disc list-inside mt-2 space-y-1 ml-5">
                                <li>Impersonating another person or entity.</li>
                                <li>Harassing, abusing, or threatening others.</li>
                                <li>Using the Services to send unsolicited messages or spam.</li>
                                <li>Interfering with or disrupting the integrity or performance of the Services.</li>
                            </ul>
                        </li>
                    </ol>
                </div>

                <div class="mt-8">
                    <h2 class="text-2xl font-semibold text-gray-900 mt-6">6. Privacy and Data Collection</h2>
                    <ol class="list-decimal list-inside mt-2 space-y-2">
                        <li>Tutorspace is committed to protecting the privacy of our users, including minors. We collect personal information such as names and email addresses solely for the purpose of providing our Services.</li>
                        <li>We do not sell or solicit any type of user data to third parties.</li>
                        <li>For users under the age of 13, we comply with the Children's Online Privacy Protection Act (COPPA) and require parental consent before collecting personal information.</li>
                        <li>By using our Services, you consent to the collection and use of your personal information as outlined in our Privacy Policy.</li>
                    </ol>
                </div>

                <div class="mt-8">
                    <h2 class="text-2xl font-semibold text-gray-900 mt-6">7. Content and Intellectual Property</h2>
                    <ol class="list-decimal list-inside mt-2 space-y-2">
                        <li>All content provided by Tutorspace, including but not limited to text, graphics, logos, and software, is protected by intellectual property laws and remains the property of Tutorspace or its licensors.</li>
                        <li>You may not reproduce, distribute, modify, create derivative works from, or otherwise use any of Tutorspace's content without prior written consent.</li>
                        <li>Tutorspace is not responsible for content provided by users, including tutors or students. Users are solely responsible for their content and may be held liable for any harm caused by such content.</li>
                    </ol>
                </div>

                <div class="mt-8">
                    <h2 class="text-2xl font-semibold text-gray-900 mt-6">8. Limitation of Liability</h2>
                    <ol class="list-decimal list-inside mt-2 space-y-2">
                        <li>Tutorspace is not liable for any indirect, incidental, special, or consequential damages arising from the use of the Services.</li>
                        <li>The maximum liability of Tutorspace for any claim related to the Services shall not exceed the amount paid by you for the Services in the twelve (12) months preceding the event giving rise to the claim.</li>
                    </ol>
                </div>

                <div class="mt-8">
                    <h2 class="text-2xl font-semibold text-gray-900 mt-6">9. Indemnification</h2>
                    <ol class="list-decimal list-inside mt-2 space-y-2">
                        <li>You agree to indemnify and hold harmless Tutorspace, its affiliates, officers, directors, employees, and agents from any claim or demand, including reasonable attorneys' fees, arising out of your use of the Services, violation of these Terms, or infringement of any third-party rights.</li>
                    </ol>
                </div>

                <div class="mt-8">
                    <h2 class="text-2xl font-semibold text-gray-900 mt-6">10. Termination</h2>
                    <ol class="list-decimal list-inside mt-2 space-y-2">
                        <li>Tutorspace reserves the right to suspend or terminate your access to the Services at any time, with or without cause, and with or without notice.</li>
                        <li>Upon termination, your right to use the Services will cease immediately. Tutorspace is not liable for any consequences of termination.</li>
                    </ol>
                </div>

                <div class="mt-8">
                    <h2 class="text-2xl font-semibold text-gray-900 mt-6">11. Changes to Terms</h2>
                    <ol class="list-decimal list-inside mt-2 space-y-2">
                        <li>Tutorspace may update these Terms from time to time. If we make material changes, we will notify you through the Services or other means.</li>
                        <li>Continued use of the Services after the changes have been made will constitute your acceptance of the new Terms.</li>
                    </ol>
                </div>

                <div class="mt-8">
                    <h2 class="text-2xl font-semibold text-gray-900 mt-6">12. Governing Law</h2>
                    <ol class="list-decimal list-inside mt-2 space-y-2">
                        <li>These Terms shall be governed by and construed in accordance with the laws of [Jurisdiction], without regard to its conflict of law principles.</li>
                    </ol>
                </div>

                <div class="mt-8">
                    <h2 class="text-2xl font-semibold text-gray-900 mt-6">13. Dispute Resolution</h2>
                    <ol class="list-decimal list-inside mt-2 space-y-2">
                        <li>Any dispute arising from these Terms or your use of the Services shall be resolved through binding arbitration in accordance with the rules of the [Arbitration Association], and the arbitration shall be held in [City, State].</li>
                    </ol>
                </div>

                <div class="mt-8">
                    <h2 class="text-2xl font-semibold text-gray-900 mt-6">14. Miscellaneous</h2>
                    <ol class="list-decimal list-inside mt-2 space-y-2">
                        <li>These Terms constitute the entire agreement between you and Tutorspace regarding the Services and supersede all prior agreements.</li>
                        <li>If any provision of these Terms is found to be unenforceable, the remaining provisions will remain in full force and effect.</li>
                        <li>Failure to enforce any right or provision in these Terms shall not constitute a waiver of such right or provision.</li>
                    </ol>
                </div>

                <div class="mt-8">
                    <h2 class="text-2xl font-semibold text-gray-900 mt-6">Contact Us</h2>
                    <p class="mt-2">If you have any questions about these Terms, please contact us at <a href="mailto:admin@tutorspace.app" class="text-blue-600 underline">admin@tutorspace.app</a>.</p>
                </div>

                </body>
            <Footer />
        </div>
    );
};

export default TermsAndConditionsPage;
